import { useEffect, useState } from 'react';
import { Box, Typography, Button, Paper, CircularProgress } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import { useNavigate } from 'react-router-dom';

const LogoutPage = () => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(20);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev === 1) {
          handleLogout();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const handleLogout = () => {
    sessionStorage.removeItem('token');
    navigate('/login');
  };

  const handleCancel = () => {
    navigate(-1);
  };

  return (
    <Box
      sx={{
        minHeight: '80vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Paper
        sx={{
          padding: 5,
          borderRadius: '20px',
          textAlign: 'center',
          width: 360,
        }}
      >
        <LogoutIcon sx={{ fontSize: 50, color: '#d32f2f', mb: 1 }} />
        <Typography variant="h6" gutterBottom>
          Oturumu kapatmak üzeresiniz
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          Çıkış yapmak istediğinize emin misiniz?
        </Typography>

        <CircularProgress
          variant="determinate"
          value={(countdown / 20) * 100}
          size={60}
          sx={{ color: '#d32f2f', mb: 2 }}
        />
        <Typography variant="body2" sx={{ mb: 3 }}>
          Otomatik çıkış: {countdown} saniye
        </Typography>

        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Button variant="contained" color="error" onClick={handleLogout}>
            Evet
          </Button>
          <Button variant="outlined" onClick={handleCancel}>
            Hayır
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default LogoutPage;
